import React from 'react';
import { withTranslation } from 'react-i18next';
import Datagrid from '../../../UI/Datagrid';
import Backend from '../../../Layouts/Backend';
import { Alert, Button } from '../../../UI/Common';
import { useHistory } from 'react-router-dom';

const SensorInfoPage = ({ t, ...props }) => {
  const history = useHistory();
  const { sensorInfo, datagridProps, errors, isFetching, sensorIds } = props;
  function getTitle() {
    if (sensorIds) {
      if (sensorIds.split(',').length > 1) {
        return `Sensor Info: <${t('Multiple alarms')}>`;
      }
      if (sensorInfo.length) {
        return `Sensor Info: ${sensorInfo[0].name}`;
      }
    } else {
    }
  }
  return (
    <Backend title={getTitle()}>
      <div className="content-inner">
        <Alert.Error text={errors} />
        <Button onClick={() => history.goBack()}>Back</Button>
        <Datagrid
          datagridProps={{
            keyField: 'sensorId',
            data: sensorInfo,
            loading: isFetching,
            ...datagridProps,
          }}
          exportProps={{
            fileName: 'SensorInfo',
          }}
          scrollX
        />
      </div>
    </Backend>
  );
};

export default withTranslation('app')(SensorInfoPage);
